import request, {requestJson} from '../main';
const service = ""
class PractitionerApi {
    private url: string = service + "/pract";
    //列表中器具详情
    public getPracttionerSum(args: any){
        return request({
            url: this.url + '/get-pract-sum',
            method: 'get',
            params: args
        })
    }
}
const practitionerApi = new PractitionerApi();
export {practitionerApi}
